<div class="row align-items-end">
    <div class="col my-auto" [class.flex-grow-0]="!esTelefono">
        <label>Limites</label>
    </div>
    <div class="col-3 col-md-2 flex-grow-0">
        <div class="mb-3">
            <label class="form-label">Min</label>
            <input type="number" class="form-control" [(ngModel)]="pregunta.MinimoItemsSeleccionados"
                [disabled]="accesoPublico">
        </div>
    </div>
    <div class="col-3 col-md-2 flex-grow-0">
        <div class="mb-3">
            <label class="form-label">Max</label>
            <input type="number" class="form-control" [(ngModel)]="pregunta.MaximoItemsSeleccionados"
                   [disabled]="accesoPublico">
        </div>
    </div>
</div>
<app-tipo-pregunta-single [accesoPublico]="accesoPublico"></app-tipo-pregunta-single>
